import { Spinner } from "@heroui/react";
import { cn } from "@heroui/theme";
import { useNavigation } from "@remix-run/react";
import { motion } from "framer-motion";

export const PrimaryButton = ({
  children,
  variant,
  baseClassName,
  ...props
}: React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> & {
  variant?: "primary" | "secondary" | "tertiary";
  baseClassName?: string;
}) => {
  const navigation = useNavigation();
  return (
    <motion.div
      layout
      className={cn(
        "rounded-full bg-primary/40 w-fit flex flex-col justify-center items-center",
        variant === "secondary" && "bg-secondary/40",
        variant === "tertiary" && "bg-neutral-600/40",
        baseClassName
      )}
    >
      <button
        {...props}
        className={cn(
          `h-full w-full flex flex-col justify-center items-center -translate-y-[5px] font-bangers text-white rounded-full bg-primary text-lg xs:text-xl 
active:translate-x-0 active:translate-y-0 disabled:translate-y-0
 font-bold px-10 py-1 disabled:opacity-50 disabled:cursor-not-allowed`,
          props.className,
          variant === "secondary" && "bg-secondary",
          variant === "tertiary" && "bg-neutral-600"
        )}
      >
        {navigation.state === "loading" || navigation.state === "submitting" ? (
          <Spinner variant="wave" color="white" className="m-0 gap-0" />
        ) : (
          <>{children}</>
        )}
      </button>
    </motion.div>
  );
};
